(function ($) {

});

// Fonction à recoder potentiellement (suppression d'un produit entier mis en attente)
function deleteCustomizedLines() {

	$(".js-basket-delete-custom-all").on('click', function () {
		var parent_product = $(this).attr('data-product-id');
		console.log(parent_product);
	});

	// $(".js-basket-delete-custom-all").on('click', function(){
	// 	var currentBasketCard = $(this).parents('.basket-card');
	// 	console.log(currentBasketCard);

	// 	currentBasketCard.find('form li.js-checkbox-parent').each(function(){
	// 		console.log($(this).attr('data-line'));
	// 		var id = $(this).attr('data-line');
	// 		$.ajax({
	// 			type: "DELETE",
	// 			url: "/api/baskets/" + window.basketId + "/lines/" + id,
	// 			headers: {
	// 				'X-CSRFToken': csrftoken
	// 			},
	// 			success: function(res){
	// 				console.log(res);
	// 				location.reload();
	// 			},
	// 			error: function(err){
	// 				console.log(err);
	// 			}
	// 		});
	// 	});
	// });
}

// Fonction à recoder potentiellement (suppression d'un produit entier mis en attente)
function deleteLines() {

	$(".js-basket-delete-all").on('click', function () {
		var currentSection = $(this).closest('section');
		// console.log(currentSection);

		currentSection.find('form li.js-checkbox-parent').each(function () {
			// console.log($(this).attr('data-line'));
			var id = $(this).attr('data-line');
			$.ajax({
				type: "DELETE",
				url: "/api/baskets/" + window.basketId + "/lines/" + id + "/",
				headers: {
					'X-CSRFToken': csrftoken
				},
				success: function (res) {
					// console.log(res);
					location.reload();
				},
				error: function (err) {
					console.log(err);
				}
			});
		})
	});
}

function deleteOneLine() {
	$('.js-basket-delete-one').on('click', function () {
		var id = $(this).parents('.js-checkbox-parent').attr('data-line');
		var url = "/api/baskets/" + window.basketId + "/lines/" + id + "/"
		$.ajax({
			type: "GET",
			url: url,
			headers: {
				'X-CSRFToken': csrftoken
			},
			success: function (res) {
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
					event: 'remove_from_cart',
					value: res.product_unit_price * res.quantity,
					ecommerce: {
						currency: res.currency,
						items: [{
							item_name: res.product_title,
							item_id: res.product_code,
							item_category: res.product_category,
							price: res.product_unit_price,
							quantity: res.quantity
						}]
					}
				});
				$.ajax({
					type: "DELETE",
					url: url,
					headers: {
						'X-CSRFToken': csrftoken
					},
					success: function (res) {
						location.reload();
					},
					error: function (err) {
						console.log('DELETE error:', err);
					}
				});
			},
			error: function (err) {
				console.log('GET error:', err);
			}
		});
	});
}

function refreshCustomPrices() {
	$('.js-custom-price').each(function () {
		var price = parseFloat($(this).attr('data-sum-price')).toFixed(2).replace('.', ',');
		// console.log(price);
		$(this).find('span').html(price);
		totalPrice();
	});
	$('.js-policy-display').each(function () {
		var selected_policy = $(this).attr('data-quantity');
		$(this).find('span').html(selected_policy);
	})
}

function updateQuantity() {
	$(".js-quantity").on("change", function () {
		$this = $(this);
		$basket = $('#basket_product_number');

		if ($this.attr('data-line-id') != -1) {
			// Basket line already exists
			// console.log($this.val());
			if (!$this.val()) $this.val(0);

			data = {
				"quantity": $this.val()
			};
			// console.log(data);
			var id = $(this).attr('data-line-id');
			$.ajax({
				type: "PUT",
				url: "/api/baskets/" + window.basketId + "/lines/" + id + "/",
				headers: {
					'X-CSRFToken': csrftoken
				},
				data: JSON.stringify(data),
				contentType: "application/json",
				success: function (res) {
					// console.log(res);
					if ($this.val() == 0) {
						// $basket = $('#basket_product_number');
						$basket.data('number', parseInt($basket.data('number')) - 1);
						$basket.text($basket.data('number'));
						$this.data('flag-zero', true);
						//Si l'on veut supprimer l'élément
						//($this).closest('.js-checkbox-parent').find('.js-basket-delete-one').trigger( "click" );
					} else if ($this.data('flag-zero') == true) {
						$basket.data('number', parseInt($basket.data('number')) + 1);
						$basket.text($basket.data('number'));
						$this.data('flag-zero', false);
					}

					// $this
					// .parents('.col-sm-12')
					// .find('.js-customization-product')
					// .attr('data-sum-price', 12);

					totalPrice()
					// DO NOT DELETE IT WILL BE USED FOR CUSTOMIZATION <<<<<<<<<<<<<<<<<<<<<<<<<<
					// if ($this.data('customized') == "True") {
					// 	// console.log("PRODUIT PERSONNALISE !!");
					// 	var update = updateCustomizationLinePrice($this);
						// $this
						// 	.parents('.col-sm-12')
						// 	.find('.js-customization-product')
						// 	.attr('data-sum-price'," update.price");
					// 	// $this
					// 	// 	.parents('.col-sm-12')
					// 	// 	.find('.js-policy-display')
					// 	// 	.attr('data-quantity', update.quantities);
					// 	// console.log(res);
					// 	refreshCustomPrices();
					// }
				},
				error: function (err) {
					console.log(err);
				}
			});
		} else {
			// Basket line must be created
			$this.prop("disabled", true); // We prevent user from changing quantity until the proper data-line-id attribute has been set for the newly created line (in AJAX success)
			var correspondingProductId = $this.parents('.js-checkbox-parent').attr('data-id');
			var correspondingProductLineId = $this.parents('.js-checkbox-parent').attr('data-line');
			var attached_to = $this.hasClass("js-sub-quantity") ? correspondingProductId : "-1";
			data = [{
				"url": "/api/products/" + $this.attr('data-id') + "/",
				"quantity": $this.val(),
				"attached_to__product_id": attached_to,
				"attached_to": correspondingProductLineId
			}];
			$.ajax({
				type: "POST",
				url: "/api/basket/add-product/",
				headers: {
					'X-CSRFToken': csrftoken
				},
				data: JSON.stringify(data),
				contentType: "application/json",
				success: function (res) {
					// var price = updateCustomizationLinePrice($this);
					// console.log(res);
					// console.log(res[0].id);
					$this.attr('data-line-id', res[0].id); // Attribute the newly created line to the data-line-id attribute in order that the next update of quantity of same product does not enter the else statement
					$this.prop("disabled", false);
					// $basket = $('#basket_product_number');
					$basket.data('number', parseInt($basket.data('number')) + data.length);
					$basket.text($basket.data('number'));
				},
				error: function (err) {
					console.log(err);
				}
			});
			// console.log(data);
		}
	});
}

function selectPolicyFilter(arr, criteria) {
	return arr.filter(function (obj) {
		return obj['min_qty'] < criteria && obj['max_qty'] >= criteria;
	});
}

function updateCustomizationLinePrice(selector) {

	// console.log(selector);
	$custom_product = selector.parents('.custom-product');
	// console.log($custom_product);
	var total_quantity_a = 0;
	var total_quantity_b = 0;
	$custom_product.find('.js-checkbox-parent').each(function () {
		$quantity = $(this).find('.js-sum-batch').first();
		$price_category = $quantity.data('price-policy');
		// console.log($price_category);
		if (parseInt($quantity.text()) && $price_category == 0) {
			total_quantity_a += parseInt($quantity.text());
		} else {
			total_quantity_b += parseInt($quantity.text());
		}
	});
	// console.log(total_quantity_a);
	// console.log(total_quantity_b);
	var selected_policy_a = selectPolicyFilter(window.regressive_policy_a, total_quantity_a)[0];
	var selected_policy_b = selectPolicyFilter(window.regressive_policy_b, total_quantity_b)[0];
	// console.log(selected_policy_a);
	// console.log(selected_policy_b);

	// -----------------------------------------------------------------------------------------
	// This version takes into account a regressive linear price (developed at first, but not the way Davoise calculates its prices)
	// var price_a = selected_policy_a ? (selected_policy_a['min_price'] + (total_quantity_a - selected_policy_a['min_qty']) * selected_policy_a['unit_price']) : 0;
	// var price_b = selected_policy_b ? (selected_policy_b['min_price'] + (total_quantity_b - selected_policy_b['min_qty']) * selected_policy_b['unit_price']) : 0;
	// console.log(price_a + price_b);
	// -----------------------------------------------------------------------------------------

	var price_a = selected_policy_a ? total_quantity_a * selected_policy_a['unit_price'] : 0;
	var price_b = selected_policy_b ? total_quantity_b * selected_policy_b['unit_price'] : 0;

	// console.log(price_a + price_b);

	return {
		price: price_a + price_b
	};
}


$(function () {
	if ($(".js-basket-delete-one").length) {
		// deleteLines();
		deleteOneLine();
		// deleteCustomizedLines();
	}

	if ($(".basket-card").length) {
		updateQuantity();
		totalPrice();

		$('.js-quantity').on('keydown', function (e) {
			if (e.keyCode == 13) {
				// $(this).next().focus();
				e.preventDefault();
			}
		});
	}
	$("#js-coupon-form").on('submit', function (e) {
		e.preventDefault();
		var code = $("#js-coupon-input").val();
		$('#voucher-error').hide()
		$.ajax({
			type: "POST",
			url: "/api/basket/add-voucher/",
			headers: {
				'X-CSRFToken': csrftoken
			},
			data: JSON.stringify({
				vouchercode: code
			}),
			contentType: "application/json",
			success: function (res) {
				window.location.reload()
			},
			error: function (err) {
                if (JSON.parse(err.responseText) == "anonymous") {
                    $('#voucher-anonymous-error').show();
                } else {
    				$('#voucher-error').text(err.reason);
    				$('#voucher-error').show();
                }

			}

		})
	});

    $(".js-delete-voucher").on('click', function(e) {

        $this = $(this);
        console.log($this.data("code"))
        $.ajax({
            type:"DELETE",
            url: "/api/basket/add-voucher/",
            headers: {
                'X-CSRFToken': csrftoken
            },
            data: JSON.stringify({vouchercode:$this.data('code')}),
            contentType: "application/json",
            success: function(res){
                window.location.reload()
            },
            error: function(err){
                console.log("It failed!");
            }
        });
    });

});

